import { usePlanDetailContext } from '@aibees/shared/features/price-and-plan/components/plan-detail/context';
import { classnames } from '@aibees/shared/utils';
import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DataPointsCheckboxGroupProps as Props } from './types';

export const DataPointsCheckboxGroup = memo(({ className, error }: Props) => {
  const { validWorkEmail, mobilePhoneNumber, fullProfileEnrichment } =
    usePlanDetailContext();

  const handleChangeDataPoints = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.name === 'email') {
      validWorkEmail.setValue(event.target.checked);
    } else if (event.target.name === 'phone') {
      mobilePhoneNumber.setValue(event.target.checked);
    } else if (event.target.name === 'profile') {
      fullProfileEnrichment.setValue(event.target.checked);
    }
  };

  return (
    <Styled.Wrapper
      className={classnames('DataPointsCheckboxGroup', className)}
      sx={SX.root}
      gap={0.5}
    >
      <Typography variant="body3" fontWeight={600} color="grey.700">
        Which data points would you like enriched per person?*
      </Typography>
      {error && (
        <Typography variant="body4" color="error">
          {error}
        </Typography>
      )}
      <Stack>
        <FormControlLabel
          control={
            <Checkbox
              checked={validWorkEmail.value}
              onChange={handleChangeDataPoints}
              name={'email'}
            />
          }
          label={
            <Typography variant="body3" color="grey.700" fontWeight={400}>
              Valid Work Email
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={mobilePhoneNumber.value}
              onChange={handleChangeDataPoints}
              name={'phone'}
            />
          }
          label={
            <Typography variant="body3" color="grey.700" fontWeight={400}>
              Mobile Phone Number
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={fullProfileEnrichment.value}
              onChange={handleChangeDataPoints}
              name={'profile'}
            />
          }
          label={
            <Typography variant="body3" color="grey.700" fontWeight={400}>
              Full Profile Detail Enrichment
            </Typography>
          }
        />
      </Stack>
    </Styled.Wrapper>
  );
});

DataPointsCheckboxGroup.displayName = 'DataPointsCheckboxGroup';
